import {
  ImportOneOnOnesCsvDocument,
  ImportOneOnOnesCsvMutation,
  OneOnOnesEmployeesDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type ImportPayload = ImportOneOnOnesCsvMutation['meetingsMutations']['importCsvMeetingsImport']
type ImportResult = ImportPayload['import']

export const useImportOneOnOnesCsv = () => {
  const [importCsv, { loading, data, error }] = useMutation(ImportOneOnOnesCsvDocument, {
    extractorFn: (response) => response.meetingsMutations.importCsvMeetingsImport,
    refetchQueries: [OneOnOnesEmployeesDocument],
  })

  const importResult: ImportResult = data?.meetingsMutations.importCsvMeetingsImport.import ?? null

  return {
    importCsv: async (file: File) => {
      // Read file content as text
      const csvContent = await file.text()

      return importCsv({
        variables: {
          csvContent,
        },
      })
    },
    loading,
    importResult,
    error,
  }
}
